// store.js
import { createStore, applyMiddleware, compose } from 'redux';
import augmentorMiddleware from './middlewares/augmentorMiddleware';
import rootReducer from './reducers';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage
import createDebounce from 'redux-debounced';
import { createLogger } from 'redux-logger';

export let store = null;
export default function createMyStore(env) {
  if (store) {
    return store;
  }

  const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['navigation', 'auth', 'testDetail'],
  };

  const initialState = {};
  const middleware = [augmentorMiddleware(), createDebounce()];

  // Optional logger only in development
  if (env?.NODE_ENV === 'development') {
    middleware.push(createLogger());
  }

  // Redux DevTools
  const enhancers = [];
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }

  const composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers
  );

  const persistedReducer =
    env && env.REACT_APP_REACT_PERSIST_SETTING === 'true'
      ? persistReducer(persistConfig, rootReducer)
      : rootReducer;

  store = createStore(persistedReducer, initialState, composedEnhancers);

  // Hot module replacement for reducers
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./reducers').default;
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}
